<script setup lang="ts">
  import type { IClpInfluencerDestinations } from '@/components/clp/influencer-block/types'
  import { ONE_WAY, RETURN } from '@/components/clp/constants'
  import type { TDirection } from '@/components/clp/types'
  import useCLPDataLayer from '@/composables/data-layers/useCLPDataLayer'
  import type { ClpInfluencerBlockStoryblok } from '@/storyblok/component-types-sb'

  const props = defineProps<{
    item: IClpInfluencerDestinations
    cherryIcon?: ClpInfluencerBlockStoryblok['cherryIcon']
  }>()

  const selectedDirection = ref<TDirection>(ONE_WAY)
  const selectDirection = (direction: TDirection) => {
    selectedDirection.value = direction
    onDirectionChange(direction)
  }

  const { pushCLPWithOriginDataLayer } = useCLPDataLayer()
  function onDirectionChange(newVal?: string) {
    if (!newVal) {
      return
    }

    pushCLPWithOriginDataLayer({
      generic_event_name: 'trip_type_selection',
      event_category: 'inspiration_section',
      trip_type: newVal === ONE_WAY ? 'OW' : 'RT',
      destination_airport_code: props.item.destinCode,
      price_from: newVal === ONE_WAY ? props.item.priceOW : props.item.priceRT
    })
  }
</script>
<template>
  <div class="grid grid-cols-1 gap-2 lg:grid-cols-12 lg:gap-4 lg:rounded-md lg:bg-white lg:p-8">
    <ClpPriceItem
      v-if="item.priceOW"
      :price="item.priceOW"
      :direction="ONE_WAY"
      :cherry-icon="cherryIcon"
      :destination="item.destinCity"
      :is-selected="selectedDirection === ONE_WAY"
      :selected-direction="selectedDirection"
      class="col-span-full !mb-0"
      :class="!item.priceRT ? 'lg:col-span-10' : 'lg:col-span-5'"
      @select-direction="selectDirection"
    />
    <ClpPriceItem
      v-if="item.priceRT"
      :price="item.priceRT"
      :direction="RETURN"
      :cherry-icon="cherryIcon"
      :destination="item.destinCity"
      :is-selected="selectedDirection === RETURN"
      :selected-direction="selectedDirection"
      class="col-span-full !mb-0"
      :class="!item.priceOW ? 'lg:col-span-10' : 'lg:col-span-5'"
      @select-direction="selectDirection"
    />
    <ClpDestinationButton
      :item="item"
      :selected-direction="selectedDirection"
      button-category="inspiration_section"
      class="col-span-full mt-2 lg:col-span-2 lg:mt-0"
    />
  </div>
</template>
